import type { IncidentListItem } from '@prerender/diagnostics-api';

import { CRAWLER_DROP_INCIDENT_TYPE, formatRequestCount, MINUS_SIGN } from './crawlerEvidenceFigures';
import { NOT_FOUND_RENDER_INCIDENT_TYPE } from './notFoundRenderFigures';
import { ORIGIN_BLOCKING_INCIDENT_TYPE } from './originBlockingFigures';
import { urlImpactLine, urlImpactOf } from './urlImpact';

export type ImpactLines = {
  primary: string;
  secondary?: string;
};

type ImpactOfIncident = Pick<
  IncidentListItem,
  'incidentType' | 'affectedUrlCount' | 'crawledUrlCount' | 'requestImpactCount'
>;

const urlLine = ({ affectedUrlCount, crawledUrlCount }: ImpactOfIncident): string =>
  urlImpactLine(urlImpactOf(affectedUrlCount, crawledUrlCount));

const originBlockingImpact = (incident: ImpactOfIncident): ImpactLines => ({
  primary: urlLine(incident),
  secondary: `${formatRequestCount(incident.requestImpactCount)} blocked requests`,
});

const notFoundRendersImpact = (incident: ImpactOfIncident): ImpactLines => ({
  primary: `${formatRequestCount(incident.requestImpactCount)} 404 renders`,
  secondary: urlLine(incident),
});

const crawlerDropImpact = (incident: ImpactOfIncident): ImpactLines => ({
  primary: `${MINUS_SIGN}${formatRequestCount(incident.requestImpactCount)} requests`,
  secondary: 'a week, against usual',
});

export function impactLines(incident: ImpactOfIncident): ImpactLines {
  switch (incident.incidentType) {
    case ORIGIN_BLOCKING_INCIDENT_TYPE:
      return originBlockingImpact(incident);
    case NOT_FOUND_RENDER_INCIDENT_TYPE:
      return notFoundRendersImpact(incident);
    case CRAWLER_DROP_INCIDENT_TYPE:
      return crawlerDropImpact(incident);
    default:
      return { primary: urlLine(incident) };
  }
}
